import React, { Component } from 'react'
import style from './style.css'

import { Col } from '../../atoms/Grid'
import Font from '../../atoms/Font'
import { Select } from '../../atoms/Forms'
import InputIcon from '../InputIcon'

class SubscribedList extends Component {

    state = {
        category: '',
        filter: ''
    }

    changeFilter(e) {
        this.setState({
            ...this.state,
            filter: e.target.value
        })
    }

    changeCategory(e) {
        this.setState({
            ...this.state,
            category: e.target.value
        })       
    }

    componentWillUpdate(nextProps, nextState) {
        if(this.state.category !== nextState.category || this.state.filter !== nextState.filter)
        this.props.handleFilter({
            category: nextState.category,
            filter: nextState.filter
        })
    }

    render() {
        return (
        <div className={`${style.listwrap}`}>
            <Col size={12}>
                <div className={`${style.list}`}>
                    <Font size='25' color='#666' weight="100" dangerouslySetInnerHTML={{__html: this.props.titleCategory}}></Font>
                    <Font size='25' color="#FF5500" weight="700">&nbsp;({this.props.titleCategoryNumber})</Font>
                </div>
                <Col size={12} className={`${style.formwrap}`}>
                    <Col size={6}>
                        <InputIcon handleChange={(e) => this.changeFilter(e)} placeholder="Procurar participante" icon="athlete"></InputIcon>
                    </Col>
                    <Col size={6}>
                        <Select value={this.state.category} handleChange={(e) => this.changeCategory(e)}>
                            <option value=''>Toda categorias</option>
                            {this.props.categories.map(category => (
                                <option key={category.id} value={category.id}>{category.description}</option>
                            ))}
                        </Select>
                    </Col>
                </Col>
            </Col>
        </div>
        )
    }
}
  
export default SubscribedList;


// WEBPACK FOOTER //
// ./src/components/molecules/SubscribedList/index.js